// Office-network self check-in — pure helpers for the settings panel and the
// review list.

/** What an admin typed (commas, spaces or new lines) → a clean list. */
export function parseAddressList(text: string): string[] {
  const out: string[] = [];
  for (const raw of text.split(/[\s,;]+/)) {
    const v = raw.trim();
    if (v && !out.includes(v)) out.push(v);
  }
  return out;
}

/**
 * A private range (192.168.x.x, 10.x, 172.16-31.x, 127.x) is how the office
 * LAN looks from INSIDE — but KaziPeople only ever sees the office's public
 * address, so one of these would refuse everybody. Caught here so the screen
 * can say so before saving; the server refuses them as well.
 */
export function looksPrivate(addr: string): boolean {
  const ip = addr.split('/')[0];
  const m = /^(\d{1,3})\.(\d{1,3})\./.exec(ip);
  if (!m) return false;
  const a = Number(m[1]);
  const b = Number(m[2]);
  return a === 10 || a === 127 || (a === 192 && b === 168) || (a === 172 && b >= 16 && b <= 31);
}

/** Whether a self-checked day needs the reviewer's attention for its location. */
export function outsideOffice(day: { clock_in_network?: string | null; clock_out_network?: string | null }): boolean {
  return [day.clock_in_network, day.clock_out_network].some((w) => w === 'outside' || w === 'unknown');
}
